import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './assets/css/font.css'
import './assets/css/styles.scss'
import moment from 'vue-moment'
import './plugins/swal'

Vue.use( moment );
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
